export class FireCollection {
    public static USER = 'user';
    public static REVIEW = 'review';
    public static LINKS = 'links';
    public static CATEGORY = 'category';
    public static DETAIL  = 'detail';
    public static SERVICE = 'service';
    public static ADS = 'ads';
    public static MENU = 'menu';
    public static QUERY_SETTING = 'query_setting';
    public static BUSINESSCATEGORY = 'business_category';
    public static PROVINCE = 'province';
    public static CITY = 'city';

    public static AMENTITY_MERCHANT = 'amenity_merhcant';
    public static AMENITY_TEMPLATE = 'amenity_template';
    public static CUSTOMER = 'customer';
    public static CUSTOMER_QUERY = 'customer_query';
}
